import { connect } from 'react-redux';
import AnimationsPanel from './AnimationsPanel';
import { saveCanvasToHistory } from '../../../actions/canvas';

const mapStateToProps = state => ({
    companyName: state && state.template.companyName,
});

const mapDispatchToProps = {
    saveCanvasToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnimationsPanel);
